import { Navigate } from 'react-router-dom';

import { EnabledRoutes } from '../features/routes/enabled';
import { SmallSpinner } from '../features/common';
import useClouderHomePath, {
  ORDERS_HOME_PATH,
} from '../hooks/useClouderHomePath';

export default function ClouderHomeRoute() {
  const { homePath, isLoading } = useClouderHomePath();

  if (isLoading) {
    return <SmallSpinner />;
  }

  if (homePath === ORDERS_HOME_PATH) {
    return <Navigate to={ORDERS_HOME_PATH} replace />;
  }

  return <EnabledRoutes />;
}
